(function () {
  function toggleOverlay(element, open) {
    if (!element) return;
    element.classList.toggle('is-open', open);
    element.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initHeader() {
    var menu = document.querySelector('[data-md-mobile-menu]');
    var scrim = document.querySelector('[data-md-drawer-scrim]');
    var menuOpen = document.querySelector('[data-md-menu-open]');
    var menuClose = document.querySelector('[data-md-menu-close]');
    var search = document.querySelector('[data-md-search]');
    var searchOpen = document.querySelector('[data-md-search-open]');
    var searchClose = document.querySelector('[data-md-search-close]');

    function setMenu(open) {
      toggleOverlay(menu, open);
      toggleOverlay(scrim, open);
      document.body.classList.toggle('md-menu-open', open);
      if (menuOpen) menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && menuClose) menuClose.focus();
    }

    function setSearch(open) {
      toggleOverlay(search, open);
      document.body.classList.toggle('md-menu-open', open);
      if (searchOpen) searchOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = search && search.querySelector('input');
        if (input) window.setTimeout(function () { input.focus(); }, 100);
      }
    }

    if (menuOpen) menuOpen.addEventListener('click', function () { setMenu(true); });
    if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
    if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
    if (searchOpen) searchOpen.addEventListener('click', function () { setSearch(true); });
    if (searchClose) searchClose.addEventListener('click', function () { setSearch(false); });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setMenu(false);
      setSearch(false);
    });
  }

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-md-slide]'));
    if (slides.length < 2) return;
    var previous = root.querySelector('[data-md-prev]');
    var next = root.querySelector('[data-md-next]');
    var pause = root.querySelector('[data-md-pause]');
    var current = 0;
    var timer = null;
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function start() {
      window.clearInterval(timer);
      if (paused) return;
      timer = window.setInterval(function () { render(current + 1); }, 5000);
    }

    function move(delta) {
      render(current + delta);
      start();
    }

    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    if (pause) {
      pause.addEventListener('click', function () {
        paused = !paused;
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        pause.textContent = paused ? '▶' : 'Ⅱ';
        start();
      });
    }

    root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', function () { window.clearInterval(timer); });
    root.addEventListener('focusout', start);

    render(0);
    start();
  }

  function initTradeGate() {
    if (!document.documentElement.classList.contains('md-public-catalog')) return;

    var productInfo = document.querySelector('product-info .product__info-container');
    if (!productInfo || productInfo.querySelector('.md-trade-gate')) return;

    var title = productInfo.querySelector('.product__title');
    var gate = document.createElement('div');
    gate.className = 'md-trade-gate';
    gate.innerHTML = '<p class="md-eyebrow">Wholesale catalogue</p>' +
      '<h2>Trade pricing &amp; availability</h2>' +
      '<p>Sign in to view your account pricing and purchasing options, or apply to become a Marbet Design stockist.</p>' +
      '<div class="md-trade-gate__actions">' +
      '<a class="md-button" href="https://trade.cbsdecor.co.za" target="_blank" rel="noopener">Trade portal</a>' +
      '<a class="md-button" href="/pages/contact">Become a stockist</a>' +
      '</div>';

    if (title) {
      title.insertAdjacentElement('afterend', gate);
    } else {
      productInfo.insertAdjacentElement('afterbegin', gate);
    }
  }

  function init() {
    initHeader();
    initTradeGate();
    Array.prototype.forEach.call(document.querySelectorAll('[data-md-slider]'), initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
